// extracted by mini-css-extract-plugin
export var body = "_e8-8";
export var button = "_e8-0";
export var closeButton = "_e8-5";
export var content = "_e8-3";
export var empty = "_e8-f";
export var grid = "_e8-c";
export var header = "_e8-4";
export var icon = "_e8-1";
export var option = "_e8-d";
export var optionSelected = "_e8-e";
export var overlay = "_e8-2";
export var searchIcon = "_e8-a";
export var searchInput = "_e8-b";
export var searchWrapper = "_e8-9";
export var title = "_e8-6";
export var visuallyHidden = "_e8-7";